import React, { useState } from "react";
import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";

const Faq = () => {
  const [openQuestion, setOpenQuestion] = useState(null);

  const toggleQuestion = (index) => {
    setOpenQuestion(openQuestion === index ? null : index);
  };

  const faqItems = [
    {
      question: "Why Should I Use TXTConnect Bulk SMS Service ?",
      answer:
        "TXTConnect Bulk SMS service offers reliable, fast message delivery with high deliverability rates. Our platform is user-friendly, cost-effective, and provides detailed delivery reports. You can reach thousands of customers instantly with personalized messages, making it ideal for marketing campaigns, notifications, and alerts.",
    },
    {
      question: "How Many SMSs Can I Send Per Hour ?",
      answer:
        "With TXTConnect, you can send thousands of SMS messages per hour. Our standard package allows for up to 10,000 messages per hour, while enterprise plans offer even higher throughput. The exact limit depends on your subscription plan, with custom solutions available for high-volume senders.",
    },
    {
      question: "Is Mass Texting Legal in Ghana ?",
      answer:
        "Yes, mass texting is legal in Ghana, but it must comply with the Data Protection Act and NCA regulations. You must have prior consent from recipients, provide opt-out options, and not send messages between 8PM and 8AM. TXTConnect ensures all messaging complies with local regulations.",
    },
    {
      question: "How Can I Legally Acquire Contact Numbers ?",
      answer:
        "You can legally acquire contact numbers through sign-up forms, customer registrations, explicit consent from individuals, purchase transactions, or business relationships. Always ensure you have documented consent and maintain proper records to comply with data protection regulations.",
    },
    {
      question: 'What Is a "Short Code" in SMS Marketing ?',
      answer:
        "A short code is a specialized, abbreviated phone number (typically 4-6 digits) used for sending and receiving text messages at high volumes. These are easier to remember than regular phone numbers and are often used for marketing campaigns, alerts, and two-factor authentication.",
    },
    {
      question: 'What Is a "Keyword" in SMS Marketing ?',
      answer:
        "A keyword in SMS marketing is a specific word that customers text to your short code to trigger an automated response or to opt into a service. Keywords are used for campaigns, promotions, polls, and subscription management, making it easy for customers to interact with your business.",
    },
    {
      question: "Can I Do a One-Time Bulk SMS Run ?",
      answer:
        "Yes, TXTConnect offers pay-as-you-go options for one-time campaigns without requiring a subscription. You can purchase credits for a single campaign of any size and use them whenever you need. Our platform is designed to accommodate both regular senders and those with occasional bulk messaging needs.",
    },
    {
      question: "Do I Need to Sign a Long-Term Agreement ?",
      answer:
        "No, TXTConnect offers flexible payment options with no long-term contracts required. You pay-as-you-go based on your needs. We believe in earning your business through quality service rather than contractual obligations.",
    },
    // {
    //   question: "Do You Have a Reporting System ?",
    //   answer:
    //     "Yes, TXTConnect provides a comprehensive reporting system with real-time delivery status, engagement metrics, and campaign performance analytics. Our dashboard shows delivery rates, open rates, click-through rates, and conversion tracking to help you measure ROI and optimize future campaigns.",
    // },
  ];

  return (
    <section className="overflow-hidden relative py-24 bg-gradient-to-b from-white to-red-50">
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div className="absolute top-0 left-0 w-1/2 h-1/2 bg-red-50 rounded-full opacity-60 mix-blend-multiply filter blur-3xl transform -translate-x-1/4 -translate-y-1/4"></div>
        <div className="absolute right-0 bottom-0 w-1/2 h-1/2 bg-yellow-50 rounded-full opacity-60 mix-blend-multiply filter blur-3xl transform translate-x-1/4 translate-y-1/4"></div>
      </div>

      <div className="relative z-10 px-4 mx-auto max-w-8xl sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="mb-16 text-center"
        >
          <h2 className="mb-5 text-4xl font-bold text-red-600 md:text-5xl">
            <span className="inline-block pb-2 border-b-4 border-red-400">
              You Have Questions ?
            </span>
          </h2>
          <p className="mx-auto mt-4 max-w-3xl text-xl text-gray-600">
            Explore our Frequently Asked Questions section to find answers to
            common queries. We're here to provide you help and ensure your
            experience is seamless.
          </p>
        </motion.div>

        <div className="mx-auto max-w-4xl">
          {faqItems.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              className="mb-4"
            >
              <button
                onClick={() => toggleQuestion(index)}
                className={`w-full text-left p-5 rounded-lg flex justify-between items-center transition-all duration-300 ${
                  openQuestion === index
                    ? "bg-red-50 shadow-md"
                    : "bg-white shadow hover:shadow-md hover:bg-gray-50"
                }`}
                aria-expanded={openQuestion === index}
              >
                <span className="font-medium text-gray-800">
                  {item.question}
                </span>
                <ChevronDown
                  className={`w-5 h-5 text-red-600 transition-transform duration-300 ${
                    openQuestion === index ? "transform rotate-180" : ""
                  }`}
                />
              </button>

              {openQuestion === index && (
                <motion.div
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.3 }}
                  className="px-5 py-4 mt-1 bg-white rounded-b-lg shadow-md"
                >
                  <p className="text-gray-600">{item.answer}</p>
                </motion.div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faq;
